export enum ButtonType {
    Primary = 'primary',
    Secondary = 'secondary',
    PrimaryLoading = 'primLoading',
    SecondaryLoading = 'secondLoading',
    SubMenuButton = 'subMenuButton',
}
